import ApolloClient from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';
import resolvers from './resolvers-client';

const client = new ApolloClient({
	cache: new InMemoryCache(),
	uri: window._env_.API_URL,
	credentials: 'include',
	clientState: {
		defaults: {
			showSubmissionPopup: false,
			showWelcomePopup: true,
			loading: false
		},
		resolvers
	},
	onError: (error) => {
		console.log(error);
		window.location.href = `${window._env_.AUTH_ENDPOINT}?r=${window.location.href}`;
		throw error;
	}
});

export default client;
